/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import FetchWrapper from "./FetchWrapper";
import { BASE_API_URL } from "@/constants";

//  A pre-configured instance of the FetchWrapper class for making API requests to the base API URL.
export const api = FetchWrapper.getInstance(BASE_API_URL);
